module.exports = __webpack_public_path__ + "img/GlobeChek.e994ee93.png";